/**
 * Browser-to-storage constraints for credential documents.
 *
 * The API persists the declared MIME type before issuing an upload grant, and
 * the malware scanner validates the uploaded bytes against that value. Keep the
 * MIME list in step with the `organization-files` bucket configuration in
 * migration 0275 and the legacy `credentials` bucket configuration.
 */
export const CREDENTIAL_DOCUMENT_UPLOAD_MAX_SIZE_BYTES = 20 * 1024 * 1024;
export const CREDENTIAL_DOCUMENT_UPLOAD_MAX_FILES = 80;
export const CREDENTIAL_DOCUMENT_UPLOAD_MAX_FILE_NAME_LENGTH = 255;
/** Allow time for both scanning and parsing before offering manual entry. */
export const CREDENTIAL_DOCUMENT_PARSE_STALLED_AFTER_MS = 5 * 60 * 1000;

export const CREDENTIAL_DOCUMENT_UPLOAD_MIME_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
  "image/webp",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
] as const;

export const CREDENTIAL_DOCUMENT_UPLOAD_EXTENSIONS = [
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  ".heic",
  ".heif",
  ".webp",
  ".docx",
] as const;
